// Privilege constants
// Must match backend Constants.cs exactly

export const PrivilegesConstants = {
  SystemAdmin: 'SystemAdmin',
  Login: 'Login',
  
  // Booking Management
  ViewBookings: 'ViewBookings',
  CreateBookings: 'CreateBookings',
  EditBookings: 'EditBookings',
  DeleteBookings: 'DeleteBookings',
  CancelBookings: 'CancelBookings',
  
  // Booking Template Management
  ViewBookingTemplates: 'ViewBookingTemplates',
  EditBookingTemplates: 'EditBookingTemplates',
  
  // Client Management
  ViewClients: 'ViewClients',
  CreateClients: 'CreateClients',
  EditClients: 'EditClients',
  DeleteClients: 'DeleteClients',
  
  // Service Management
  ViewServices: 'ViewServices',
  CreateServices: 'CreateServices',
  EditServices: 'EditServices',
  DeleteServices: 'DeleteServices',
  
  // Service Pass Management
  ViewServicePasses: 'ViewServicePasses',
  EditServicePasses: 'EditServicePasses', // Includes Create/Edit/Delete
  
  // Client Service Pass Management
  ViewClientServicePasses: 'ViewClientServicePasses',
  EditClientServicePasses: 'EditClientServicePasses', // Includes Create/Edit/Delete
  
  // Employee Management
  ViewEmployees: 'ViewEmployees',
  CreateEmployees: 'CreateEmployees',
  EditEmployees: 'EditEmployees',
  DeleteEmployees: 'DeleteEmployees',
  
  // Waitlist Management
  ViewWaitlist: 'ViewWaitlist',
  CreateWaitlist: 'CreateWaitlist',
  EditWaitlist: 'EditWaitlist',
  DeleteWaitlist: 'DeleteWaitlist',
  
  // Lookup Management
  ViewLookups: 'ViewLookups',
  EditLookups: 'EditLookups',
  ManageLookups: 'ManageLookups',
  
  // Qualification Management
  ViewQualifications: 'ViewQualifications',
  CreateQualifications: 'CreateQualifications',
  EditQualifications: 'EditQualifications',
  DeleteQualifications: 'DeleteQualifications',
  
  // Room Management
  ViewRooms: 'ViewRooms',
  CreateRooms: 'CreateRooms',
  EditRooms: 'EditRooms',
  DeleteRooms: 'DeleteRooms',
  
  // User Management
  ViewUsers: 'ViewUsers',
  CreateUsers: 'CreateUsers',
  EditUsers: 'EditUsers',
  DeleteUsers: 'DeleteUsers',
  
  // Role Management
  ViewRoles: 'ViewRoles',
  CreateRoles: 'CreateRoles',
  EditRoles: 'EditRoles',
  DeleteRoles: 'DeleteRoles',
  
  // System Settings Management
  ManageSystemSettings: 'ManageSystemSettings',
  
  // Security Audit
  ViewSecurityAudit: 'ViewSecurityAudit',
  
  // Suggestion Management - Therapist to Client Suggestions
  ViewSuggestions: 'ViewSuggestions',
  CreateSuggestions: 'CreateSuggestions',
  EditSuggestions: 'EditSuggestions',
  DeleteSuggestions: 'DeleteSuggestions',
  
  // Notification Management
  ViewAllNotifications: 'ViewAllNotifications',
  ResendNotifications: 'ResendNotifications',
  
  // Reports
  ViewReports: 'ViewReports'
} as const;
